import { render, staticRenderFns } from "./afasCompanyInput.vue?vue&type=template&id=bd5a824a&"
import script from "./afasCompanyInput.vue?vue&type=script&lang=js&"
export * from "./afasCompanyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports